function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-check

import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, Thumbs, A11y, FreeMode, Keyboard, Mousewheel, Zoom } from 'swiper/modules';
import { common as twConfig } from '../../../../tailwind/common.config';
import { showSelectedVariant, getVariantIndex } from './product-detail-page';
import { debounce } from '../common';
Swiper.use([Navigation, Pagination, Autoplay, Thumbs, A11y, FreeMode, Keyboard, Mousewheel, Zoom]);
export var selectors = Object.freeze({
  pdp_media_parent: '.product__media',
  parent: '[data-items-element="swiper__parent"]',
  carousel: '[data-items-element="swiper__viewport"]',
  wrapper: '[data-items-element="swiper-wrapper"]',
  slide: '[data-items-element="swiper-slide"]',
  next: '.swiper__navigation--next',
  prev: '.swiper__navigation--prev',
  pagination: '.swiper__pagination',
  counter: '.swiper-pagination',
  activeCounter: '.swiper-pagination-bullet-active',
  thumbnails: {
    wrapper: '[data-items-element="swiper-wrapper--thumbs"]',
    parent: '.swiper--thumbs',
    carousel: '.swiper-viewport--thumbs',
    thumbs: '.swiper--thumbs .swiper-thumb'
  },
  activeThumbnail: '.swiper-slide-thumb-active'
});

/** initialize all carousels */
export function carouselInit() {
  /** @type {NodeListOf<HTMLElement>} */
  var parents = document.querySelectorAll(selectors.parent);
  parents.forEach(function (parent) {
    initSingleCarousel(parent);
  });
}
var initSingleCarousel = function initSingleCarousel(parent) {
  var _parent$dataset$carou;
  var carousel = parent.querySelector(selectors.carousel);
  if (!(carousel instanceof HTMLElement)) return;
  /** @type {HTMLElement | null} */
  var paginationElement = parent.querySelector(selectors.pagination);
  var prevEl = parent.querySelector('.swiper__navigation--prev');
  var nextEl = parent.querySelector('.swiper__navigation--next');
  var hasNav = prevEl instanceof HTMLElement && nextEl instanceof HTMLElement;
  var autoplayDelay = parseFloat((_parent$dataset$carou = parent.dataset.carouselAutoplay) !== null && _parent$dataset$carou !== void 0 ? _parent$dataset$carou : '0') * 1000;
  var spaceBetweenX = getSpaceBetween(parent);
  var slidesPerView = getSlidesPerView(parent);
  var slidesPerGroup = getSlidesPerGroup(parent);
  var responsiveLayout = getResponsiveLayout(parent);
  var peek = getPeek(parent);
  /** @type {NodeListOf<HTMLElement>} */
  var wrappers = parent.querySelectorAll(selectors.wrapper);
  /** @type {NodeListOf<HTMLElement>} */
  var slides = parent.querySelectorAll(selectors.slide);
  var slideCount = slides.length;
  var paginationAriaLabel = paginationElement === null || paginationElement === void 0 ? void 0 : paginationElement.dataset.label;
  var breakpoint = getBreakpointString(responsiveLayout, breakpoints);
  var mediaQuery = window.matchMedia(breakpoint);
  var initialVariantIndex = getVariantIndex();
  var zoom = parent.dataset.carouselZoom === 'true';
  var paginationType = parent.dataset.carouselPaginationType;

  // Add swiper styles
  wrappers.forEach(function (wrapper) {
    return wrapper.classList.add('swiper-wrapper');
  });
  slides.forEach(function (slide) {
    return slide.classList.add('swiper-slide');
  });

  // Prevent duplicate swiper aria-live regions
  var notifications = parent.querySelectorAll('.swiper-notification');
  if (notifications) notifications.forEach(function (notification) {
    return notification.remove();
  });

  // Exit if there are no active breakpoints
  if (breakpoint.length <= 0) return;
  var swiperThumbs = getThumbs(carousel);
  var slideActiveCounter = parent.querySelector(selectors.activeCounter);
  var slideCounter = parent.querySelector(selectors.counter);
  if (slideActiveCounter) slideActiveCounter.textContent = "1";
  if (slideCounter) slideCounter.textContent = "".concat(slideCount);
  var swiperOptions = {
    slidesPerView: slidesPerView.sm + (peek.sm.enabled ? peek.sm.value : 0),
    slidesPerGroup: slidesPerGroup.sm,
    initialSlide: initialVariantIndex,
    navigation: {
      enabled: hasNav,
      nextEl: '.swiper__navigation--next',
      prevEl: '.swiper__navigation--prev'
    },
    pagination: {
      type: paginationType,
      el: paginationElement,
      clickable: true,
      renderBullet: function renderBullet(index, className) {
        return "<button class=\"".concat(className, "\" aria-label=\"").concat(paginationAriaLabel === null || paginationAriaLabel === void 0 ? void 0 : paginationAriaLabel.replace('{{ index }}', index.toString()), "\"></button>");
      }
    },
    createElements: true,
    resizeObserver: true,
    spaceBetween: spaceBetweenX,
    thumbs: {
      swiper: swiperThumbs
    },
    autoplay: autoplayDelay > 0 ? {
      delay: autoplayDelay
    } : undefined,
    loop: parent.dataset.carouselLoop === 'true' && slideCount > 2,
    centeredSlides: parent.dataset.carouselAlign === 'center',
    freeMode: parent.dataset.carouselDragfree === 'true',
    zoom: zoom,
    keyboard: {
      enabled: true,
      onlyInViewport: true
    },
    mousewheel: {
      forceToAxis: true
    },
    a11y: {
      enabled: true
    },
    breakpoints: _defineProperty(_defineProperty({}, breakpoints.md, {
      slidesPerView: slidesPerView.md + (peek.md.enabled ? peek.md.value : 0),
      slidesPerGroup: slidesPerGroup.md,
      centeredSlides: parent.dataset.carouselAlignMd === 'center'
    }), breakpoints.lg, {
      slidesPerView: slidesPerView.lg + (peek.md.enabled ? peek.md.value : 0),
      slidesPerGroup: slidesPerGroup.lg,
      centeredSlides: parent.dataset.carouselAlignMd === 'center'
    }),
    on: {
      activeIndexChange: function activeIndexChange(swiper) {
        // Clicking thumbs de-syncs state
        // and causes arrows to be disabled even if isBeginning and isEnd != true
        // To fix, we reset the nav/pagination, and then remove disabled attrs from
        // navigation if the swiper is not actually at the beginning/end
        swiper.pagination.render();
        swiper.navigation.destroy();
        swiper.navigation.init();
        if (!swiper.isBeginning && !swiper.isEnd) {
          [swiper.navigation.nextEl, swiper.navigation.prevEl].forEach(function (el) {
            if (!(el instanceof HTMLElement) || typeof el === 'undefined') return;
            el.setAttribute('aria-disabled', 'false');
            el.removeAttribute('disabled');
          });
        }
        if (zoom) {
          swiper.zoom.out();
        }
      }
    }
  };
  var swiperObject = null;
  if (mediaQuery.matches) {
    swiperObject = new Swiper(carousel, swiperOptions);
    parent.dataset.carouselSlideCount = swiperObject.slides.length;
    if (zoom) {
      // TODO: Do we need to scope this to the swiper parent?
      zoomInline(swiperObject);
    }
  }
  mediaQuery.addEventListener('change', function (e) {
    if (e.matches) {
      if (!swiperObject || swiperObject.destroyed) {
        swiperObject = new Swiper(carousel, swiperOptions);
        if (zoom) {
          zoomInline(swiperObject);
        }
      }
    } else {
      if (swiperObject && !swiperObject.destroyed) {
        swiperObject.destroy(true, true);
      }
    }
  });
  return swiperObject;
};

/**
 * getBreakpointString
 * @param {Object} responsiveLayout - Object {sm, md, lg} - where each ['left', 'center', 'carousel', 'carousel_peek']
 * @returns {String} CSS Media Query e.g. (max-width: 680px), (min-width: 681px) and (max-width: 1024px), (min-width: 2000px)
 */
var getBreakpointString = function getBreakpointString(responsiveLayout, breakpoints) {
  var arr = [];
  if (responsiveLayout.sm === 'carousel' || responsiveLayout.sm === 'carousel_peek') {
    arr.push("(max-width:".concat(breakpoints.md - 1, "px)"));
  }
  if (responsiveLayout.md === 'carousel' || responsiveLayout.md === 'carousel_peek') {
    arr.push("(min-width:".concat(breakpoints.md, "px) and (max-width:").concat(breakpoints.lg - 1, "px)"));
  }
  if (responsiveLayout.lg === 'carousel' || responsiveLayout.lg === 'carousel_peek') {
    arr.push("(min-width:".concat(breakpoints.lg, "px)"));
  }
  return arr.join(',');
};
function zoomInline(swiper) {
  var _document$querySelect;
  (_document$querySelect = document.querySelectorAll(selectors.thumbnails.thumbs)) === null || _document$querySelect === void 0 || _document$querySelect.forEach(function (thumbEl) {
    thumbEl.addEventListener('click', function () {
      swiper.zoom.out();
      var index = swiper.thumbs.swiper.clickedIndex;
      swiper.slideTo(index);
    });
  });
  var zoomChanged = false;
  swiper.on('zoomChange', function (_swiper, scale) {
    if (scale > 1) {
      swiper.allowSlideNext = false;
      swiper.allowSlidePrev = false;
      zoomChanged = true;
    } else {
      swiper.allowSlideNext = true;
      swiper.allowSlidePrev = true;
      zoomChanged = false;
    }
  });
  swiper.on('navigationPrev', function () {
    if (zoomChanged) {
      swiper.zoom.out();
      var index = swiper.realIndex - 1;
      swiper.slideTo(index);
    }
  });
  swiper.on('navigationNext', function () {
    if (zoomChanged) {
      swiper.zoom.out();
      var index = swiper.realIndex + 1;
      swiper.slideTo(index);
    }
  });
}

/**
 * slideToIndex
 *  @param {Number} index - index to scroll pdp carousel to
 */
function slideToIndex(swiperChildElement, index) {
  /** @type {HTMLElement & { swiper?: Swiper } | null } */
  var swiperParent = swiperChildElement.closest('.product__media [data-items-element="swiper__parent"] .swiper-initialized');
  if (!(swiperParent instanceof HTMLElement)) return;
  var swiperObject = swiperParent.swiper;
  if (!swiperObject) return;

  // Navigate and disable animation temporarily
  var originalSpeed = swiperObject.params.speed;
  swiperObject.slideTo(index, 0);
  setTimeout(function () {
    swiperObject.params.speed = originalSpeed;
  }, 0);
}

/**
 * getPeek
 * @param {HTMLElement| undefined} parent - carousel parent element
 * @returns {Object}
 */
var getPeek = function getPeek(parent) {
  if (parent === undefined) {
    return {
      sm: false,
      md: false
    };
  }
  return {
    sm: {
      enabled: parent.dataset.carouselPeek === 'true',
      value: parseFloat(parent.dataset.carouselPeekValue || '0.5')
    },
    md: {
      enabled: parent.dataset.carouselPeekMd === 'true',
      value: parseFloat(parent.dataset.carouselPeekValueMd || '0.5')
    }
  };
};

/**
 * getSpaceBetween
 * @param {Element} parentEl - gap size, values should match liquid settings.grid_gap_x
 * @returns {Number | undefined}
 */

function getSpaceBetween(parentEl) {
  var rem = parseInt(getComputedStyle(parentEl).getPropertyValue('--grid-gap-x'));
  return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
}

/**
 * getThumbs
 * @param {HTMLElement} el - the carousel's parent element
 * @returns {Swiper | undefined}
 */
function getThumbs(el) {
  // Setup thumbnail carousel (if exists)
  var parentEl = el.closest(selectors.pdp_media_parent);
  if (!(parentEl instanceof HTMLElement)) return;
  var thumbParentEl = parentEl.querySelector(selectors.thumbnails.parent);
  if (!(thumbParentEl instanceof HTMLElement)) return;
  var directionMd = thumbParentEl.dataset.directionMd === 'vertical' ? 'vertical' : 'horizontal';
  var centered = thumbParentEl.dataset.centered === 'center';
  var centeredMd = thumbParentEl.dataset.centeredMd === 'center';

  /** @type {HTMLElement | null} */
  var carouselEl = thumbParentEl.querySelector(selectors.thumbnails.carousel);
  if (!carouselEl) return;
  var thumbs = new Swiper(carouselEl, {
    slidesPerView: 'auto',
    spaceBetween: 12,
    direction: 'horizontal',
    initialSlide: 0,
    resizeObserver: true,
    watchOverflow: true,
    watchSlidesProgress: true,
    keyboard: {
      enabled: true,
      onlyInViewport: true
    },
    centerInsufficientSlides: centered,
    a11y: {
      enabled: true
    },
    breakpoints: _defineProperty({}, breakpoints.md, {
      direction: directionMd,
      centerInsufficientSlides: centeredMd
    })
  });
  var thumbsParent = el.querySelector(selectors.wrapper);
  if (thumbsParent) {
    var pdpHeight = thumbsParent.getBoundingClientRect().height;
    if (pdpHeight > 0) {
      carouselEl.style.setProperty('max-height', pdpHeight + 'px');
    } else {
      carouselEl.style.removeProperty('max-height');
    }
  }
  return thumbs;
}

/**
 * get the number of slides per view for each breakpoint
 * @param {HTMLElement} el - the carousel's parent element
 * @returns {{ sm: number, md: number, lg: number }}
 */
function getSlidesPerView(el) {
  var sm = el.dataset.slidesPerView !== undefined ? parseFloat(el.dataset.slidesPerView) : 0;
  var md = el.dataset.slidesPerViewMd !== undefined ? parseFloat(el.dataset.slidesPerViewMd) : 0;
  var lg = el.dataset.slidesPerViewLg !== undefined ? parseFloat(el.dataset.slidesPerViewLg) : 0;
  return {
    sm: sm,
    md: md,
    lg: lg
  };
}

/**
 * get the number of slides per view for each breakpoint
 * @param {HTMLElement} el - the carousel's parent element
 * @returns {{ sm: string, md: string, lg: string }}
 */
function getResponsiveLayout(el) {
  var sm = el.dataset.carouselLayout !== undefined ? el.dataset.carouselLayout : '';
  var md = el.dataset.carouselLayoutMd !== undefined ? el.dataset.carouselLayoutMd : '';
  var lg = el.dataset.carouselLayoutMd !== undefined ? el.dataset.carouselLayoutMd : '';
  return {
    sm: sm,
    md: md,
    lg: lg
  };
}

/**
 * get the number of slides per view for each breakpoint
 * @param {HTMLElement} el - the carousel's parent element
 * @returns {{ sm: number, md: number, lg: number }}
 */
function getSlidesPerGroup(el) {
  var _el$dataset$slidesPer, _el$dataset$slidesPer2, _el$dataset$slidesPer3;
  var sm = parseInt((_el$dataset$slidesPer = el.dataset.slidesPerView) !== null && _el$dataset$slidesPer !== void 0 ? _el$dataset$slidesPer : '1', 10) || 1;
  var md = parseInt((_el$dataset$slidesPer2 = el.dataset.slidesPerViewMd) !== null && _el$dataset$slidesPer2 !== void 0 ? _el$dataset$slidesPer2 : '1', 10) || sm;
  var lg = parseInt((_el$dataset$slidesPer3 = el.dataset.slidesPerViewLg) !== null && _el$dataset$slidesPer3 !== void 0 ? _el$dataset$slidesPer3 : '1', 10) || md;
  return {
    sm: sm,
    md: md,
    lg: lg
  };
}

/** breakpoint values from tailwind config (in px) */
var breakpoints = {
  // @note: parseFloat will strip the 'px' suffix
  md: parseFloat(twConfig.theme.extend.screens.md),
  lg: parseFloat(twConfig.theme.extend.screens.lg)
};

/**
 * Only show images of selected variant
 * @param {CustomEvent} event - fired in variant-selector.js
 */
document.addEventListener('umg:variant:change', function (event) {
  if (!(event instanceof CustomEvent)) return;
  showSelectedVariant(event.detail.variantId);
});

/**
 * Navigate to variant image
 * @param {CustomEvent} event - fired in variant-selector.js
 */
document.addEventListener('umg:variant:change', function (event) {
  if (!(event instanceof CustomEvent)) return;

  // Get button from the image url
  var srcArray = event.detail.previewImageSrc.split('/');
  var src = srcArray[srcArray.length - 1];
  var imageInCarousel = document.querySelector(".pdp-image-wrapper img[src*=\"".concat(src, "\"]"));
  var imageInCarouselParentButton = imageInCarousel === null || imageInCarousel === void 0 ? void 0 : imageInCarousel.closest('button');

  // Get index from button
  var index = parseInt((imageInCarouselParentButton === null || imageInCarouselParentButton === void 0 ? void 0 : imageInCarouselParentButton.dataset.index) || '-1');
  if (index < 0) return;
  slideToIndex(imageInCarouselParentButton, index);
});
document.addEventListener('DOMContentLoaded', function () {
  carouselInit();
});